import {Inject, Service} from "vue-typedi";
import {fabricationApiClient} from "@/configuration/api-client";
import {OrderedProductsList} from "@/model/OrderedProductsList";
import { OrderedProductStatus } from "../model/OrderedProductStatus";
import { StoreService } from "./StoreService";
import { Quantity } from "@/model/Quantity";

@Service()
export class OrderedProductService {

    @Inject()
    private storeService!: StoreService;

    static ORDERED_PRODUCTS_ENDPOINT: string = '/orderedProducts';
    private static readonly STORE_ID: string = "storeId";

    public getOrderedProducts(): Promise<OrderedProductsList>  {
        const params = new URLSearchParams();
        const store: string = sessionStorage.getItem(OrderedProductService.STORE_ID);
        if (store != null) {
            params.append('store', store);
        }

        const zones = this.storeService.selectedAndEnabledZones;
        if (zones != null) {
            zones.forEach(zone => params.append('zones', zone));
        }
        
        return fabricationApiClient.get(OrderedProductService.ORDERED_PRODUCTS_ENDPOINT, { params: params })
            .then((response: any) => {
                const data: OrderedProductsList = response && response.data ? response.data : {};
                return Promise.resolve(data);
            }).catch(error => {
                return Promise.reject(error);
            });
    }

    public changeOrderedProductState(cug: string, orderIds: string[], newState: OrderedProductStatus, processedQuantity: Quantity): Promise<OrderedProductsList> {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return fabricationApiClient.put(OrderedProductService.ORDERED_PRODUCTS_ENDPOINT + "/" + cug + "/status", { orderIds: orderIds, storeId: sessionStorage.getItem(OrderedProductService.STORE_ID), targetStatus: newState, quantityProcessed: processedQuantity}, config)
            .then((response: any) => {
                const data: OrderedProductsList = response && response.data ? response.data : {};
                return Promise.resolve(data);
            }).catch(error => {
                return Promise.reject(error);
            });
    }
}